import { render, staticRenderFns } from "./yesScore.vue?vue&type=template&id=c79b1672&scoped=true&"
import script from "./yesScore.vue?vue&type=script&lang=js&"
export * from "./yesScore.vue?vue&type=script&lang=js&"
import style0 from "./yesScore.vue?vue&type=style&index=0&id=c79b1672&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79b1672",
  null
  
)

export default component.exports